'use strict';

DoohApps
.service('clientSoftwareBLL', ['$location', 'ClientSoftware', 'DoohConfig', 'SessionHelper', 'FileDownloadHelper',
        function ($location, ClientSoftware, DoohConfig, SessionHelper, FileDownloadHelper) {
        var _this = this;

        this.objectFilterOptions = {
            offset: 0,
            count: 20
        }

        this.getClientSoftwareList = function (callback) {
            ClientSoftware.getClientSoftwareList(function (data) {

                var softList = data.Data.Content;

                angular.forEach(softList, function (v, k) {
                    v.URL = DoohConfig.RestApiBaseURL + 'ClientSoftware/GetClientSoftware?FileName=' + v.FileName + '&access_token=' + SessionHelper.GetAccessToken();
                    v.DirectURL = DoohConfig.RestApi + '/DownloadClientSoftware/' + v.FileName;
                });

                callback(softList)

            }, _this.objectFilterOptions);
        }

        this.getClientSoftware = function (callback, fileName) {
            ClientSoftware.getClientSoftware(function (data) { callback('Here you go') }, { 'fileName': fileName });
        }

        this.getDownloadUrl = function (callback, jsonData) {
            ClientSoftware.getDownloadUrl(function (data) { callback(data); }, jsonData);
        }

        this.getLatestVersion = function (callback) {
            ClientSoftware.getLatestVersion(function (data) { callback(data); });
        }

        this.getDownloadUrlByID = function (fileID) {
            ClientSoftware.getDownloadUrlByID(function (data) {
                responseHandler(FileDownloadHelper.downloadFileFromResponse, data);
            }, fileID);
        }

        function responseHandler(callback, data) {
            callback({
                hasError: (data.Data != undefined && data.Data.error != undefined) || data.error != undefined || data.error_description != undefined,
                error: data.error_description || data.error || (data.Data != undefined ? data.Data.error : null),
                message: data.message || (data.Data != undefined ? data.Data.message : null),
                content: (data.Data != undefined) ? ((data.Data.Content != undefined) ? data.Data.Content : null) : null
            });
        }
}]);